import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, MenuItem, Select, InputLabel, FormControl, CircularProgress, Snackbar, Alert } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import axios from 'axios';
import { useAuth } from '../../../components/AuthContext';
import { useNavigate } from "react-router-dom";

const RegistarFolhaDespesas = () => {
  const { userInfo } = useAuth();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');
  const [aprovadoresCliente, setAprovadoresCliente] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [aprovador1Disabled, setAprovador1Disabled] = useState(false);
  const [aprovador2Disabled, setAprovador2Disabled] = useState(false);
  const [grupoI, setGrupoI] = useState('');
  const [files, setFile] = useState("");

  const navigate = useNavigate();

  const fetchAprovadorNome = async (id) => {
    try {
      const response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${id}`);
      return response.data.nome;
    } catch (error) {
      console.error(`Erro ao buscar nome do aprovador com id ${id}:`, error);
      return '';
    }
  };

  const initialValues = {
    data: "",
    clienteId: "",
    valorTotal: "",
    kms: "",
    matricula: "",
    percursoCompleto: "",
    notas: "",
    tipoDespesa: "",
    aprovador1: "",
    aprovador2: "",
    ficheiro: null,
    colaboradorId: userInfo.id,
    projetoId: "",
    faturado: false,
    estado: "Pendente",
    grupoi: "",
    grupoii: ""
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [clientesResponse, colaboradoresResponse] = await Promise.all([
          axios.get('https://pf-auditores.ew.r.appspot.com/api/clientes'),
          axios.get('https://pf-auditores.ew.r.appspot.com/api/colaboradores')
        ]);
        setClientes(clientesResponse.data);
        setColaboradores(colaboradoresResponse.data);
      } catch (error) {
        console.error('Erro ao buscar clientes e colaboradores:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleClienteChange = async (event, handleChange, setFieldValue) => {
    const clienteId = event.target.value;
    setSelectedCliente(clienteId);
    handleChange(event);

    if (clienteId) {
      try {
        const response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/clientes/${clienteId}`);
        const { aprovador1, aprovador2 } = response.data;
        const nomeAprovador1 = await fetchAprovadorNome(aprovador1);
        const nomeAprovador2 = await fetchAprovadorNome(aprovador2);
        setAprovadoresCliente([
          { id: aprovador1, nome: nomeAprovador1 },
          { id: aprovador2, nome: nomeAprovador2 }
        ]);

        // Atualiza os valores dos campos de aprovadores no Formik
        setFieldValue('aprovador1', aprovador1);
        setFieldValue('aprovador2', aprovador2);
      } catch (error) {
        console.error('Erro ao buscar aprovadores do cliente:', error);
      }
    } else {
      setAprovadoresCliente([]);
      setFieldValue('aprovador1', '');
      setFieldValue('aprovador2', '');
    }
  };

  const handleFormSubmit = async (values, actions) => {
    setIsSubmitting(true);
    try {
      let ficheiroUrl = '';
      if (values.ficheiro) {
        const formData = new FormData();
        formData.append('file', values.ficheiro);
        const uploadResponse = await axios.post('https://pf-auditores.ew.r.appspot.com/api/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(progress);
          },
        });
        ficheiroUrl = uploadResponse.data.fileUrl;
      }

      const updatedDespesaData = {
        ...values,
        ficheiro: ficheiroUrl,
        projetoId: parseInt(values.clienteId, 10),
        colaboradorId: userInfo.id,
        clienteId: parseInt(values.clienteId, 10),
        aprovador1: parseInt(values.aprovador1, 10),
        aprovador2: parseInt(values.aprovador2, 10),
      };

      console.log('Dados a serem enviados para o backend:', JSON.stringify(updatedDespesaData, null, 2));

      const response = await axios.post('https://pf-auditores.ew.r.appspot.com/api/folha-despesas', updatedDespesaData);

      if (response.status === 201) {
        actions.resetForm();
        setAlertMessage('Despesa registrada com sucesso');
        setAlertOpen(true);
        navigate('/despesas');
      } else {
        setAlertMessage('Erro ao registrar despesa: ' + response.statusText);
        setAlertOpen(true);
      }
    } catch (error) {
      setAlertMessage('Erro ao registrar despesa: ' + error.message);
      setAlertOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleGrupoChange = (event, setFieldValue) => {
    const { name, value } = event.target;
    setFieldValue(name, value);
    setFieldValue('clienteId', '');
    setSelectedCliente('nomeCliente');
    setAprovadoresCliente([]);
    if (name === 'grupoI') {
      setGrupoI(value);
    } 
  };

  const filteredClientes = clientes.filter(cliente => {
    return (
      (grupoI === '' || cliente.grupoI === grupoI) 
    );
  });
console.log(filteredClientes)
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Header title="Registar Folha de Despesas" subtitle="Registar nova folha de despesas" />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="date"
                label="Data"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.data}
                name="data"
                error={!!touched.data && !!errors.data}
                helperText={touched.data && errors.data}
                sx={{ gridColumn: "span 1" }}
                InputLabelProps={{ shrink: true }}
              />
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 1" }}>
                <InputLabel>Grupo I</InputLabel>
                <Select
                  name="grupoI"
                  value={grupoI}
                  onBlur={(e) => {
                    handleBlur(e);
                    handleGrupoChange(e, setFieldValue);
                  }}
                  onChange={(e) => {
                    handleGrupoChange(e, setFieldValue);
                  }}                  
                >
                  <MenuItem value="">Nenhum</MenuItem>
                  {[...new Set(clientes.map(cliente => cliente.grupoI))].map(grupo => (
                    <MenuItem key={grupo} value={grupo}>
                      {grupo}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>           
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 2" }}>
                <InputLabel>Cliente</InputLabel>
                <Select
                  name="clienteId"
                  value={selectedCliente}
                  onChange={(e) => handleClienteChange(e, handleChange, setFieldValue)}
                  onBlur={handleBlur}
                  error={!!touched.clienteId && !!errors.clienteId}
                >
                  <MenuItem value="">Nenhum</MenuItem>
                  {filteredClientes.map(cliente => (
                    <MenuItem key={cliente.id} value={cliente.id}>
                      {cliente.nomeCliente}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                variant="filled"
                label="Valor Total"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.valorTotal}
                name="valorTotal"
                error={!!touched.valorTotal && !!errors.valorTotal}
                helperText={touched.valorTotal && errors.valorTotal}
                sx={{ gridColumn: "span 1" }}
              />
              <FormControl variant="filled" fullWidth sx={{ gridColumn: "span 1" }}>
                <InputLabel>Tipo de Despesa</InputLabel>
                <Select
                  name="tipoDespesa"
                  value={values.tipoDespesa}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.tipoDespesa && !!errors.tipoDespesa}
                >
                  <MenuItem value="Deslocação em viatura própria">Deslocação em viatura própria</MenuItem>
                  <MenuItem value="Refeições">Refeições</MenuItem>
                  <MenuItem value="Outras despesas">Outras despesas</MenuItem>
                </Select>
                {touched.tipoDespesa && errors.tipoDespesa && (
                  <div style={{ color: 'red', marginTop: 8 }}>{errors.tipoDespesa}</div>
                )}
              </FormControl>
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Percurso Completo"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.percursoCompleto}
                name="percursoCompleto"
                error={!!touched.percursoCompleto && !!errors.percursoCompleto}
                helperText={touched.percursoCompleto && errors.percursoCompleto}
                sx={{ gridColumn: values.tipoDespesa === "Deslocação em viatura própria" ? "span 2" : "span 2" }}
              />
              {values.tipoDespesa === "Deslocação em viatura própria" && (
                <>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="number"
                    label="Kms"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.kms}
                    name="kms"
                    error={!!touched.kms && !!errors.kms}
                    helperText={touched.kms && errors.kms}
                    sx={{ gridColumn: "span 1" }}
                    inputProps={{ min: "0" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Matricula"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.matricula}
                    name="matricula"
                    error={!!touched.matricula && !!errors.matricula}
                    helperText={touched.matricula && errors.matricula}
                    sx={{ gridColumn: "span 1" }}
                  />
                </>
              )}
              <TextField
                fullWidth
                name="aprovador1"
                value={aprovadoresCliente.length > 0 ? aprovadoresCliente[0].nome : ''}
                onBlur={handleBlur}
                variant="filled"
                onChange={handleChange}
                label="Aprovador 1"
                error={!!touched.aprovador1 && !!errors.aprovador1}
                disabled     
                type="text"
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                name="aprovador2"
                value={aprovadoresCliente.length > 0 ? aprovadoresCliente[1].nome : ''}
                onBlur={handleBlur}
                variant="filled"
                onChange={handleChange}
                label="Aprovador 2"
                error={!!touched.aprovador2 && !!errors.aprovador2}
                disabled     
                type="text"
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Notas"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.notas}
                name="notas"
                error={!!touched.notas && !!errors.notas}
                helperText={touched.notas && errors.notas}
                sx={{ gridColumn: "span 4" }}
              />
              <Box
                fullWidth
                display="flex"
                alignItems="center"
                gap={1}
                sx={{ gridColumn: 'span 3' }}
              >
                <input
                  type="file"
                  accept=".pdf,.png,.jpeg"
                  id="upload-file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFieldValue("ficheiro", file);
                      setUploadProgress(0); // Reset progress on new file selection
                      console.log(`Arquivo selecionado: ${file.name}`); // Log do nome do arquivo
                      setFile(file.name);
                    }
                  }}
                  style={{ display: 'none' }}
                />
                <label htmlFor="upload-file">
                  <Button variant="contained" component="span">
                    Carregar Ficheiro
                  </Button>
                </label>
                {values.ficheiro && (
                  <>
                    <Button variant="contained" color="error" onClick={() => setFieldValue("ficheiro", null)}>Remover</Button>
                    <CircularProgress variant="determinate" value={uploadProgress} color="success" />
                    {values.ficheiro && <span>{values.ficheiro.name}</span>}
                  </>
                )}
                <span><b>Limite de upload:</b> 10MB</span>
              </Box>
            </Box>
            <Box sx={{ gridColumn: "span 4", display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button variant="contained" color="primary" onClick={() => navigate("/horas")}>
                Voltar
              </Button>
              <Button type="submit" color="secondary" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={24} /> : 'Guardar'}
              </Button>
            </Box>
          </form>
        )}
      </Formik>

      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity="error" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  data: yup.string().required("Data é obrigatória"),
  clienteId: yup.string().required("Cliente é obrigatório"),
  valorTotal: yup.number().required("Valor total é obrigatório"),
  kms: yup.string().required("Kms é obrigatório"),
  matricula: yup.string().required("Matricula é obrigatória"),
  percursoCompleto: yup.string().required("Percurso completo é obrigatório"),
  notas: yup.string(),
  tipoDespesa: yup.string().required("Tipo de despesa é obrigatório"),
  aprovador1: yup.string(),
  aprovador2: yup.string(),
  ficheiro: yup.mixed(),
  colaboradorId: yup.string(),
  projetoId: yup.string(),
  faturado: yup.boolean(),
  estado: yup.string(),
  grupoi: yup.string(),
  grupoii: yup.string()
});

export default RegistarFolhaDespesas;
